<script>
import VueSlideBar from "vue-slide-bar";

import Layout from "../../layouts/main";
import appConfig from "@/app.config";

import ExchangeApi from "@/services/exchange-api";
import CountriesApi from "@/services/countries-api";

import Swal from "sweetalert2";


export default {
  page: {
    title: "Echange des produits",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { VueSlideBar, Layout },
  data() {
    return {
      selectedAnnouncment:null,
      announcmentsList:[],
      othersAnnouncmentsList:[],
      pagemodelMain: {currentPage : 1, perPage : 10, totalRows: 0},
      pageMain: {currentPage : 1, perPage : 6, totalRows: 0},
      isTableBusy:false,
      isAnnouncmentsTableBusy:false,
      productTitleFilter:null,
      expirationDateFiler:null,
      citiesList:[],
      cityFilter:null,
      sliderPriceFilter:null,
      maxPrice:0,
    };
  },
  mounted(){
    this.getOthersAnnoucments();
    this.getCities();
    this.getMaxPrice();

    this.getMyAnnoucments()
  },
  methods: {
    getMyAnnoucments(){
        this.isTableBusy = true;
      ExchangeApi.getMyAnnoucments(this.pagemodelMain.currentPage, this.pagemodelMain.perPage).then(
          result => {
            this.announcmentsList = result.list
            this.pagemodelMain.totalRows = result.total;
            this.pagemodelMain.currentPage = result.page;
            this.pagemodelMain.perPage = result.pageSize;
            this.pagemodelMain.pageSize = result.pageSize;
        })
        .finally(() => {
        this.isTableBusy = false;
      })
     
    },

    getOthersAnnoucments(){
       this.isAnnouncmentsTableBusy = true;
      ExchangeApi.getOthersAnnoucments(this.pageMain.currentPage, this.pageMain.perPage,this.productTitleFilter,this.expirationDateFiler,this.cityFilter ?this.cityFilter.id : null,this.sliderPriceFilter).then(
          result => {
            this.othersAnnouncmentsList = result.list
            this.pageMain.totalRows = result.total;
            this.pageMain.currentPage = result.page;
            this.pageMain.perPage = result.pageSize;
            this.pageMain.pageSize = result.pageSize;
        })
        .finally(() => {
          this.isAnnouncmentsTableBusy = false;
      })
    },

    saveAnnouncment(){
      ExchangeApi.saveAnnouncment(this.selectedAnnouncment).then(
          (result)=>{
            if(result){
              this.getMyAnnoucments();
              this.getOthersAnnoucments();
              this.closeModal();
            }
          }
      )
    },

    deleteAnnouncment() {

      Swal.fire({
      title:  'Supprimer ?' ,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#f46a6a",
      cancelButtonText: "Annuler",
      confirmButtonText: 'Oui, supprimer' 
      }).then(result => {
          if (result.value) {
            ExchangeApi.deleteAnnouncment(this.selectedAnnouncment).then(
              (result)=>{
                if(result){
                  this.getMyAnnoucments();
                  this.getOthersAnnoucments();
                }
              }
            )
          }
      })
    },

    addNew(){
      this.selectedAnnouncment={id:null,productTitle:'',price:0,description:'',expirationDate:'',stateForSwitch:true};
      this.showModal = true;
    },

    getCities(){
       CountriesApi.getCurrentCustomerCities().then(
          result => {
            this.citiesList = result
        })
     },

     getMaxPrice(){
       ExchangeApi.getMaxPrice().then(
         (result) => {
           this.maxPrice =result;
         }
       )
     },
     closeModal(){
        this.showModal=false
        this.selectedAnnouncment=null;
     }
   
  },

};
</script>

<template>
  <Layout>
    <b-modal v-if="selectedAnnouncment" v-model="showModal" 
    title="Details de l'Annonce" 
    centered 
    title-class="text-warning"
    title-tag="h5"
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    header-close-variant="danger">
        <template v-slot:modal-footer>
          <b-button class="zoom-container" variant="secondary" @click="closeModal()" size="md">Annuler</b-button>
          <b-button class="zoom-container" variant="primary" @click="saveAnnouncment()" size="md" >Publier l'annonce</b-button>
        </template>
        <div class="zoom-container">
        <b-form-group>
          <label class="pt-1 pb-1 font-weight-bold font-20">Produit <span class="text-danger mb-2" style="font-size:9px">(obligatoire)</span></label>
          <input
          type="text"
          class="form-control font-size-13 "
          v-model="selectedAnnouncment.productTitle"
          />
        </b-form-group>

        <b-form-group>
          <label  class="pt-1 pb-1 font-weight-bold font-20">Date de Péremption</label>
          <input  v-mask="'##/####'" type="text" v-model="selectedAnnouncment.expirationDate" class="form-control" placeholder="Entrer une date" />
        </b-form-group>

        <b-form-group>
          <label  class="pt-1 pb-1 font-weight-bold font-20">Description de l'annonce</label>
          <textarea
            v-model="selectedAnnouncment.description"
            class="form-control"
            :maxlength="225"
            rows="4"
            placeholder="Limite de 225 caractéres."
          ></textarea>
          <div class="text-center">
            <p
              v-if="selectedAnnouncment.description"
              class="badge position-absolute"
              :class="{ 'badge-success': selectedAnnouncment.description.length !== 225,
                        'badge-danger': selectedAnnouncment.description.length === 225 }"
            >
              {{ selectedAnnouncment.description.length }} /
              225
            </p>
          </div>
        </b-form-group>

        <b-form-group>
          <label  class="pt-1 pb-1 font-weight-bold font-20">Prix</label>
            <input v-model="selectedAnnouncment.price" type="number"  class="form-control"  />
        </b-form-group>
<!-- v-model needs a boolean -->
        <!-- <b-form-checkbox v-model="selectedAnnouncment.stateForSwitch" switch class="mb-1 mt-4">
          <label>Publier cette Annonce</label>
        </b-form-checkbox> -->
      <!-- <button type="button" class="btn btn-primary float-right" @click="saveAnnouncment()" >Enregistrer</button> -->
        </div>
    </b-modal>
    <div class="row pt-4 pb-4">
          <div class="col-md-8 col-sm-8">
            <div class="mt-2">
              <h2 class="card-title font-size-20">Annonces d'échanges d'articles</h2>
            </div>
          </div>
      </div>


    <div class="row ">

      
      <div class="col-md-4 pr-md-4 pb-4">
        <div class="card p-3 border border-light" style="min-height:59em">
        <b-tabs justified content-class="text-muted">
          <b-tab active @click="getMyAnnoucments()"  class="border-0" lazy >
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-cogs font-size-14"></i>
              </span>
              <i class="d-none d-sm-inline-block fas fa-cogs font-size-14 pr-2"/><span class="d-none d-sm-inline-block font-size-14">Mes Annonces</span>
            </template>
            <div class="card " style="min-height:48em">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-7 ">
                    <h4 class="card-title mt-2"><u>Liste de mes Annonces</u></h4>
                  </div>
                  <div class="col-sm-5">
                  <b-button variant="primary" size="sm" style="float:right;" @click="addNew()" >
                    <i class="fas fa-plus-square font-size-12 font-weight-bold align-middle mr-2"></i> <span class=" font-weight-bold font-size-12">Nouvelle</span>
                  </b-button>
                  </div>
                </div>
                <div class="row">
                  <div class="table-responsive mt-0">
                    <table class="table project-list-table table-striped table-borderless table-centered " >
                      <thead>
                        <tr>
                          <th scope="col"  style=""></th>
                          <th scope="col"  style="width:20px"></th>
                          <th scope="col"  style="width:10px"></th>
                          <th scope="col"  style="width:10px"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(announcment) in this.announcmentsList" :key="announcment.id" >
                          <td>
                             <a :class="announcment.stateForSwitch ? 'font-size-12 text-primary font-weight-bold' : 'font-size-12 text-primary font-weight-bold text-muted'" @click="selectedAnnouncment=announcment;showModal=true;" style="cursor: pointer;"> {{announcment.productTitle}} </a>                      
                          </td>
                           <td>
                             <span :class="announcment.stateForSwitch ? 'font-size-12 text-primary' : 'font-size-12 text-primary text-muted'">{{announcment.expirationDate}}</span>  
                          </td>
                          <td>
                            <b-button variant="link"  size="sm" title="Editer l'annonce" ><i class="font-size-12 fas fa-pencil-alt text-warning" @click="selectedAnnouncment=announcment;showModal=true;"></i></b-button>   
                          </td>
                          <td>
                            <b-button variant="link"  size="sm" title="Supprimer l'annonce" ><i class="font-size-12 fas fa-trash-alt text-danger" @click="selectedAnnouncment=announcment;deleteAnnouncment();"></i></b-button>   
                          </td>
                        </tr>
                      </tbody>
                    </table>
                      <div v-if="isTableBusy" class="d-flex justify-content-center">
                          <div class="spinner-border text-success" role="status">
                              <span class=" sr-only">Chargement...</span>
                          </div>
                      </div>
                      <span v-if="!isTableBusy && !announcmentsList.length" class="d-flex justify-content-center m-4 text-danger" >Aucune Annonce dans la liste</span>

                  </div>
                </div>
              


              </div>
            </div>
              <!-- Pagination -->
                <div class="row pt-3 pl-4 pr-4 mb-sm-4">
                    <div class="col-sm-8">
                        <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                            <b-form-select @input="getMyAnnoucments()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                            <!-- <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} lignes</span></div> -->
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="dataTables_paginate paging_simple_numbers float-right">
                            <ul class="pagination pagination-rounded mb-0">
                            <b-pagination v-model="pagemodelMain.currentPage" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="getMyAnnoucments()" ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div> 
                <!-- Fin Pagination  --> 
          </b-tab>
          <b-tab class="border-0" lazy >
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-search font-size-14"></i>
                </span>
                <i class="d-none d-sm-inline-block fas fa-search font-size-14 pr-2"/><span class="d-none d-sm-inline-block font-size-14">Recherches</span>
              </template>
              <div class="card " style="min-height:39em"> 
                <div class="card-body">
                  <div class="row">
                      <h4 class="card-title mb-4"><u>Filtres de Recherche</u></h4>
                  </div>
                  <h5 class="font-size-14 mb-1 pt-3 pb-2">Région</h5>
                  <div class="row">
                    <div class="col-12">
                      <v-select class="style-vselect" style="font-size: 17px" placeholder="Ville" label="name" :options="citiesList" v-model="cityFilter">
                        <span slot="no-options">Aucun élément dans la liste</span>
                      </v-select>
                    </div>
                  </div>

                  <h5 class="font-size-14 mb-1 mt-4 pt-3 pb-2">Produit</h5>
                  <div class="row">
                    <div class="col-sm-12">
                      <b-form-input type="text"  placeholder="Cherchez un produit ..." v-model="productTitleFilter" @keyup.native.enter="getOthersAnnoucments()"></b-form-input>
                    </div>
                  </div>
                  <h5 class="font-size-14 mb-1 mt-4 pt-3 pb-2">Date de Péremption</h5>
                  <div class="row">
                    <div class="col-12">
                       <input  v-mask="'##/####'" type="text" v-model="expirationDateFiler" class="form-control" placeholder="Aprés le" />
                    </div>
                  </div>

                  <h5 class="font-size-14 mb-1 mt-4 pt-3">Prix HT supérieur à</h5>
                  <div class="row">
                    <div class="col-12">
                      <vue-slide-bar  v-model="sliderPriceFilter" 
                        :min="0" :max="maxPrice" >
                      </vue-slide-bar>
                    </div>
                  </div>

                  <div class="row pb-0 pt-4">
                    <div class="col-sm-12">
                        <b-button variant="secondary" style="width:100%" @click="getOthersAnnoucments()" :disabled="this.isAnnouncmentsTableBusy">
                          <b-spinner small :class="this.isAnnouncmentsTableBusy ? '' : 'd-none'"></b-spinner>
                          <i v-if="!this.isAnnouncmentsTableBusy " class="bx bx-search font-size-24 align-middle mr-2"></i> <span class="font-weight-bold font-size-14">Lancer une recherche</span>
                        </b-button>
                    </div>
                  </div>

                
                </div>
              </div>
          </b-tab>
          
        </b-tabs>
        </div>
         
      </div>
 
      <div class="col-md-8 ">
  <div style="min-height:59em">
        <div class="row">
          <div class="col-4"/>
          <div class="col-4">
            <div v-if="isAnnouncmentsTableBusy" class="d-flex justify-content-center">
                <div class="spinner-border text-success" role="status">
                    <span class=" sr-only">Chargement...</span>
                </div>
            </div>
          </div>
          <div class="col-4"/>
        </div>
        <div class="row">
              <div class="col-4"/>
              <div class="col-4">

                <span v-if="!isAnnouncmentsTableBusy && !othersAnnouncmentsList.length" class="d-flex justify-content-center  text-danger text-center" >Aucune Annonce dans la liste</span>
              </div>
              <div class="col-4"/>
        </div>
        
        <div class="row" :style="[!othersAnnouncmentsList.length ? {'min-height': '40em'} : {} ]">
          <div  v-for="(othersAnnouncment) in this.othersAnnouncmentsList" :key="othersAnnouncment.id" class="col-md-4 col-sm-6 pr-4 pb-4 ">
            <div class="card ">
              <div class="card-body ">
                <div class="product-img position-relative">
                </div>
                <div class="mt-1 mb-1 text-center">
                  <h5 class="mb-3 text-truncate font-size-18 ">
                    <span tag="a" class="text-dark" >{{othersAnnouncment.productTitle}}</span>
                  </h5>

                  <h5 class="mb-1 text-truncate font-size-12 badge badge-primary"><i class="fas fa-plus mr-2"/>{{othersAnnouncment.customerName}}</h5>
                </div>

                <div class="row mt-4 text-center">
                    <div class="col-12 ">
                      <span class="text-primary" style="text-align:justify"> 
                            <i v-if="othersAnnouncment.customerPhone" class="fas fa-phone  mr-2" />{{othersAnnouncment.customerPhone}}
                            <i v-if="othersAnnouncment.customerMail" class="fas fa-envelope ml-2 mr-2"/>{{othersAnnouncment.customerMail}}
                        </span>
                    </div>
                </div>

                <div class="row mt-1 mb-4 text-center">
                    <div v-if="othersAnnouncment.customerAddress" class="col-12">
                      <span class="text-primary" style="text-align:justify"> 
                            <i class="fas fa-map-marker  mr-2" />{{othersAnnouncment.customerAddress}}
                        </span>
                    </div>
                </div>

            
            <div class="row pt-4">
              <div class=col-6>
                <h5 class="font-size-15 ">Annonce :</h5>
              </div>

              <div class=col-6>
                <h5 class="text-dark font-size-12 pull-right text-right"><i>{{othersAnnouncment.formattedCreationDate}}</i></h5>
              </div>
            </div>
              

            <div  class="mb-1" style="min-height:100px">
            <p class="text-muted" style="text-align:justify">
              {{othersAnnouncment.description}}  </p>

            </div>

              <div class="row mt-3">
                  <div class="col-6 text-left pull-left">
                    <span class="mb-0 text-muted font-weight-bold">Date de Péremption</span>
                    <h5 class="font-size-15 mb-1 text-danger"><i class="far fa-calendar-check mr-2" title="Date de péremption" />{{othersAnnouncment.expirationDate}}</h5>
                    
                  </div>

                <div class="col-6 text-right pull-right">
                  <span class="mb-0 text-muted font-weight-bold">Prix HT</span>
                  <h5 class="font-size-15 mb-left1 text-success">{{othersAnnouncment.priceAsString}} TND</h5>
                </div>
                
              </div>
                  
                </div>
              </div>
            </div>
        </div>
        </div>
        <!-- Pagination -->
        <div class="row pt-3 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getOthersAnnoucments()"  v-model="pageMain.perPage" size="sm" style="width: 60px" :options="[6,9,12,15]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pageMain.totalRows}} lignes</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pageMain.currentPage" :disabled="isAnnouncmentsTableBusy" :per-page="pageMain.pageSize" :total-rows="pageMain.totalRows" @input="getOthersAnnoucments()" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
      </div>





        <!-- end row -->

    </div>



  </Layout>
</template>